import { DriveFile, Organization, OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useState } from 'react'
import { Api } from '~/core/trpc'
import { useSdk } from './useSdk'

type Options = {
  organization: Organization
  organizationMember: OrganizationMember
}

export const useDriveFiles = ({
  organization,
  organizationMember,
}: Options) => {
  const [isLoading, setIsLoading] = useState(false)
  const sdk = useSdk({ organizationMember })

  const where = {
    organizationMemberId: organizationMember?.id,
  }

  const driveFilesQuery = Api.driveFile.findMany.useQuery(
    {
      where,
      orderBy: {
        updatedAt: 'desc',
      },
    },
    { initialData: [] },
  )

  const updateDriveFile = async (driveFileUpdated: Partial<DriveFile>) => {
    try {
      setIsLoading(true)

      await sdk.updateOneFile({
        driveFile: {
          content: driveFileUpdated.content,
          name: driveFileUpdated.name,
        },
      })

      await driveFilesQuery.refetch()
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    } finally {
      setIsLoading(false)
    }

    await driveFilesQuery.refetch()
  }

  const deleteDriveFile = async (driveFile: DriveFile) => {
    try {
      await sdk.deleteOneFile({
        driveFileId: driveFile.id,
      })

      await driveFilesQuery.refetch()
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  return {
    driveFiles: driveFilesQuery.data,
    isLoading: driveFilesQuery.isLoading || isLoading,
    updateDriveFile,
    deleteDriveFile,
    refetch: driveFilesQuery.refetch,
  }
}
